// extracted by mini-css-extract-plugin
export default {"configurator-init":"main_configurator-init__Ok17V","configurator-active":"main_configurator-active__VBNow"};